/*
 * Tyee Archery — Tariff-Free Zone (sections/tyee-tariff-free-zone.liquid).
 * Loads the compact zone index (/collections/<handle>?view=zone-index&page=N, 250 per page),
 * then searches / filters / sorts it in the browser. The Liquid-rendered cards stay until the
 * index arrives, so the section is never empty.
 * URL state on the full page: ?q= &d= (department) &c= (category) &b= (brand) &s= (sort) &stock=1 &free=1
 */
(function () {
  'use strict';

  var money = (function () {
    try {
      var f = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
      return function (c) { return f.format(c / 100); };
    } catch (e) {
      return function (c) { return '$' + (c / 100).toFixed(2); };
    }
  })();

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ');
  }

  var cache = {};
  function loadIndex(handle, count) {
    var key = 'tfz:v2:' + handle + ':' + count;
    if (cache[key]) return cache[key];
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.exp > Date.now()) return (cache[key] = Promise.resolve(o.items));
      }
    } catch (e) { /* storage unavailable */ }
    var pages = Math.max(1, Math.ceil(count / 250));
    var reqs = [];
    for (var i = 1; i <= pages; i++) {
      reqs.push(
        fetch('/collections/' + encodeURIComponent(handle) + '?view=zone-index&page=' + i, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        })
          .then(function (r) { if (!r.ok) throw new Error('zone index HTTP ' + r.status); return r.text(); })
          .then(function (t) { return JSON.parse(t).items || []; })
      );
    }
    cache[key] = Promise.all(reqs).then(function (parts) {
      var items = [].concat.apply([], parts);
      items.forEach(function (it, n) {
        it.ix = n;
        it.hay = norm([it.t, it.v, it.y].join(' '));
      });
      try { sessionStorage.setItem(key, JSON.stringify({ exp: Date.now() + 15 * 60 * 1000, items: items })); } catch (e) { /* quota */ }
      return items;
    });
    return cache[key];
  }

  function card(it) {
    var price = (it.m > it.p ? 'From ' : '') + money(it.p);
    if (it.c > it.p) price += ' <s>' + money(it.c) + '</s>';
    var pills = (it.s ? '<span class="tyee-pill tyee-pill--stock">In stock</span>' : '') +
      (it.f ? '<span class="tyee-pill tyee-pill--free">Tariff-free</span>' : '');
    var img = it.i ? '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" loading="lazy" width="480" height="480">' : '';
    // in-stock series: open the product in Tariff-Free Zone mode on its first in-stock option
    var href = '/products/' + encodeURIComponent(it.h) + '?' + (it.u ? 'variant=' + it.u + '&' : '') + 'tfz=1';
    var opts = (!it.f && it.n > 1 && it.o) ? '<span class="tfz-card__opts">' + it.o + ' of ' + it.n + ' options in stock</span>' : '';
    return '<li><a class="tfz-card" href="' + href + '">' +
      '<span class="tfz-card__img">' + img + '</span>' +
      '<span class="tfz-card__body">' +
      '<span class="tfz-card__vendor">' + esc(it.v) + '</span>' +
      '<span class="tfz-card__title">' + esc(it.t) + '</span>' +
      '<span class="tfz-card__price">' + price + '</span>' + opts +
      '<span class="tfz-card__pills">' + pills + '</span>' +
      '</span></a></li>';
  }

  function init(root) {
    var full = root.dataset.mode === 'full';
    var handle = root.dataset.handle;
    var count = parseInt(root.dataset.count, 10) || 0;
    var step = parseInt(root.dataset.step, 10) || 8;
    var depts = [];
    try { depts = JSON.parse(root.querySelector('[data-tfz-config]').textContent); } catch (e) { /* none */ }
    depts.forEach(function (d) {
      d.all = (d.p ? [d.p] : []).concat(d.c.map(function (c) { return c[1]; }));
    });

    var $ = function (s) { return root.querySelector(s); };
    var q = $('[data-tfz-q]'), dSel = $('[data-tfz-d]'), cSel = $('[data-tfz-c]'), bSel = $('[data-tfz-b]');
    var sortSel = $('[data-tfz-sort]'), stockCb = $('[data-tfz-stock]'), freeCb = $('[data-tfz-free]');
    var grid = $('[data-tfz-grid]'), countEl = $('[data-tfz-count]'), empty = $('[data-tfz-empty]');
    var more = $('[data-tfz-more]'), allLink = $('[data-tfz-all]'), allN = $('[data-tfz-all-n]');
    var inStock = $('[data-tfz-instock]');
    var pinned = (root.dataset.pinned || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);

    // the zone opens on a hand-picked set; searching or re-sorting drops it
    function pinFirst(list) {
      var rank = {};
      pinned.forEach(function (h, i) { rank[h] = i; });
      var head = [], tail = [];
      list.forEach(function (it) { (rank[it.h] === undefined ? tail : head).push(it); });
      head.sort(function (a, b) { return rank[a.h] - rank[b.h]; });
      return head.concat(tail);
    }
    var form = $('[data-tfz-form]');
    var items = null, shown = step, timer = 0;

    // initial state from the URL (full page) so the homepage hand-off lands pre-filtered
    var params = new URLSearchParams(location.search);
    if (full) {
      if (params.get('q')) q.value = params.get('q');
      if (sortSel && params.get('s')) sortSel.value = params.get('s');
      if (stockCb) stockCb.checked = params.get('stock') === '1';
      if (freeCb) freeCb.checked = params.get('free') === '1';
    }

    function inDept(it, d) {
      for (var i = 0; i < it.k.length; i++) if (d.all.indexOf(it.k[i]) !== -1) return true;
      return false;
    }

    function base(skip) {
      // every filter except the one named in skip (so each dropdown can show counts for its own options)
      var words = norm(q.value).split(' ').filter(Boolean);
      var d = depts[dSel.value] || null;
      return items.filter(function (it) {
        for (var w = 0; w < words.length; w++) if (it.hay.indexOf(words[w]) === -1) return false;
        if (skip !== 'd' && d && !inDept(it, d)) return false;
        if (skip !== 'c' && cSel.value && it.k.indexOf(cSel.value) === -1) return false;
        if (skip !== 'b' && bSel && bSel.value && it.v !== bSel.value) return false;
        if (stockCb && stockCb.checked && !it.s) return false;
        if (freeCb && freeCb.checked && !it.f) return false;
        return true;
      });
    }

    function fillDepts() {
      var pool = base('d'), keep = dSel.value;
      dSel.innerHTML = '<option value="">All departments (' + pool.length + ')</option>' + depts.map(function (d, i) {
        var n = pool.filter(function (it) { return inDept(it, d); }).length;
        return n ? '<option value="' + i + '">' + esc(d.n) + ' (' + n + ')</option>' : '';
      }).join('');
      dSel.value = keep;
      if (dSel.value !== keep) dSel.value = '';
    }

    function fillCats() {
      var pool = base('c'), keep = cSel.value, d = depts[dSel.value];
      var list = d ? d.c : [].concat.apply([], depts.map(function (x) { return x.c; }));
      var html = '<option value="">' + (d ? 'All ' + esc(d.n.toLowerCase()) : 'All categories') + '</option>';
      list.forEach(function (c) {
        var n = pool.filter(function (it) { return it.k.indexOf(c[1]) !== -1; }).length;
        if (n) html += '<option value="' + esc(c[1]) + '">' + esc(c[0]) + ' (' + n + ')</option>';
      });
      cSel.innerHTML = html;
      cSel.value = keep;
      if (cSel.value !== keep) cSel.value = '';
    }

    function fillBrands() {
      if (!bSel) return;
      var pool = base('b'), keep = bSel.value, counts = {};
      pool.forEach(function (it) { counts[it.v] = (counts[it.v] || 0) + 1; });
      bSel.innerHTML = '<option value="">All brands</option>' + Object.keys(counts).sort(function (a, b) {
        return a.localeCompare(b);
      }).map(function (v) {
        return '<option value="' + esc(v) + '">' + esc(v) + ' (' + counts[v] + ')</option>';
      }).join('');
      bSel.value = keep;
      if (bSel.value !== keep) bSel.value = '';
    }

    function sorted(list) {
      var s = sortSel ? sortSel.value : '';
      var out = list.slice();
      if (s === 'price-asc') out.sort(function (a, b) { return a.p - b.p || a.ix - b.ix; });
      else if (s === 'price-desc') out.sort(function (a, b) { return b.p - a.p || a.ix - b.ix; });
      else if (s === 'az') out.sort(function (a, b) { return a.t.localeCompare(b.t); });
      else if (s === 'stock') out.sort(function (a, b) { return b.s - a.s || a.ix - b.ix; });
      else if (!full) out.sort(function (a, b) { return b.s - a.s || a.ix - b.ix; }); // homepage: shelf stock first
      return out;
    }

    function stateParams() {
      var p = new URLSearchParams();
      if (q.value.trim()) p.set('q', q.value.trim());
      if (dSel.value !== '') p.set('d', depts[dSel.value] ? depts[dSel.value].n : '');
      if (cSel.value) p.set('c', cSel.value);
      if (bSel && bSel.value) p.set('b', bSel.value);
      if (sortSel && sortSel.value) p.set('s', sortSel.value);
      if (stockCb && stockCb.checked) p.set('stock', '1');
      if (freeCb && freeCb.checked) p.set('free', '1');
      return p;
    }

    function render() {
      fillDepts(); fillCats(); fillBrands();
      var list = sorted(base(''));
      var filtered = q.value.trim() || dSel.value !== '' || cSel.value || (bSel && bSel.value) ||
        (stockCb && stockCb.checked) || (freeCb && freeCb.checked);
      // "Featured" means our pick first, here and on the homepage. Searching, choosing a
      // department / category / brand, or picking a sort order hands the order back to the shopper;
      // the in-stock and tariff-free chips only narrow the set, so the pins stay on top of it.
      var steered = q.value.trim() || dSel.value !== '' || cSel.value ||
        (bSel && bSel.value) || (sortSel && sortSel.value);
      if (!steered && pinned.length) list = pinFirst(list);
      grid.innerHTML = list.slice(0, shown).map(card).join('');
      empty.hidden = list.length > 0;
      countEl.textContent = filtered
        ? list.length + ' of ' + items.length + ' tariff-free products'
        : items.length + ' products ready to ship tariff-free';
      if (more) more.hidden = list.length <= shown;
      var p = stateParams();
      if (allLink) {
        allLink.href = root.dataset.url + (p.toString() ? '?' + p.toString() : '');
        if (allN) allN.textContent = filtered ? list.length : items.length;
      }
      if (inStock) {
        // same search / department / category the shopper is looking at, plus the in-stock filter
        var ps = stateParams();
        ps.set('stock', '1');
        inStock.href = root.dataset.url + '?' + ps.toString();
      }
      if (full) {
        var url = location.pathname + (p.toString() ? '?' + p.toString() : '');
        history.replaceState(null, '', url);
      }
    }

    function changed() { shown = step; if (items) render(); }

    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(changed, 120); });
    [dSel, bSel, sortSel, stockCb, freeCb].forEach(function (el) {
      if (el) el.addEventListener('change', function () { if (el === dSel) cSel.value = ''; changed(); });
    });
    cSel.addEventListener('change', changed);
    if (more) more.addEventListener('click', function () { shown += step; render(); });
    form.addEventListener('submit', function (e) {
      if (!full && items) { e.preventDefault(); location.href = allLink.href; return; }
      if (items) e.preventDefault();
    });

    root.setAttribute('data-loading', '');
    loadIndex(handle, count).then(function (list) {
      items = list;
      root.removeAttribute('data-loading');
      if (full) {
        // restore dropdowns from the URL now that options can be built
        var dn = params.get('d');
        if (dn) depts.forEach(function (d, i) { if (d.n === dn) dSel.value = String(i); });
        fillDepts();
        if (dn) depts.forEach(function (d, i) { if (d.n === dn) dSel.value = String(i); });
        fillCats();
        if (params.get('c')) cSel.value = params.get('c');
        fillBrands();
        if (bSel && params.get('b')) bSel.value = params.get('b');
      }
      render();
    }).catch(function (e) {
      root.removeAttribute('data-loading');
      console.warn('[tyee-zone] index failed, keeping the server-rendered cards', e);
    });
  }

  function boot() { document.querySelectorAll('[data-tfz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
